import { InjectionToken, type Signal } from '@angular/core';

export type FilterLayoutMode = 'block' | 'inline';

export interface FilterLayoutContext {
    layoutMode: Signal<FilterLayoutMode>;
}

export const FILTER_LAYOUT_CONTEXT = new InjectionToken<FilterLayoutContext>(
    'FilterLayoutContext'
);
